var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWechatqrcode({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2257 2257",
    style: {
      enableBackground: "new 0 0 2257 2257"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#006039;}\n\t.st1{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 610,
    y: 122,
    className: "st0",
    width: 61,
    height: 61
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1525,
    y: 122,
    className: "st0",
    width: 61,
    height: 61
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1281,
    y: 183,
    className: "st0",
    width: 61,
    height: 61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1403,244 1464,244 1464,305 1525,305 1586,305 1586,244 1525,244 1525,183 1464,183 1464,122  1403,122 1342,122 1342,183 1403,183  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "915,244 915,183 915,122 854,122 854,183 854,244 793,244 793,183 793,122 732,122 732,183 732,244  732,305 732,366 793,366 793,427 854,427 915,427 915,366 854,366 854,305 915,305 976,305 976,244  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1159,305 1159,244 1220,244 1220,183 1281,183 1281,122 1220,122 1159,122 1098,122 1037,122 976,122  976,183 1037,183 1098,183 1098,244 1037,244 1037,305 1098,305  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 732,
    y: 488,
    className: "st0",
    width: 61,
    height: 61
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1342,
    y: 488,
    className: "st0",
    width: 61,
    height: 61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1647,488 1647,427 1647,366 1586,366 1586,427 1586,488 1586,549 1647,549  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 610,
    className: "st0",
    width: 61,
    height: 61
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2074,
    y: 610,
    className: "st0",
    width: 61,
    height: 61
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1952,671v-61h-61h-61h-61h-61h-61h-61v-61h-61v-61v-61h-61v-61v-61h-61v-61h-61v61h-61h-61h-61v61v61h-61v61 v61h-61v-61v-61v-61v-61h-61v61v61v61v61v61h61h61v61h-61h-61h-61v61h61h61v61h61v-61h61v-61h61v-61h61v-61v-61h-61v61h-61v-61h61 v-61h61v61h61v-61h61v61h61v61h-61v61h-61h-61v61h61h61h61v-61h61v61v61h-61h-61h-61v61h-61h-61v-61h-61v61h-61v61h61h61v61h61v-61 h61v61h61v-61h61v-61h61v61v61h-61h-61v61h61h61v61h-61h-61h-61v-61v-61h-61v61v61v61h61v61h61v61h61h61v61h-61v61v61h61v61h-61 h-61v-61h-61v-61v-61h-61v61v61h-61h-61v61h61v61h-61h-61v-61h-61h-61h-61v61v61v61h61v-61v-61h61v61h61h61h61h61v-61v-61h61v61h61 v61h-61h-61v61h61h61h61v61h-61v61h-61h-61h-61v-61h-61v61h-61v61h61h61v61h61v-61h61v61h61v-61h61v-61h61v-61v-61h61v61v61v61v61 h-61h-61v61h-61v61h-61v-61v-61h-61v61h-61v-61h-61h-61v61v61h61v61v61h61v-61v-61h61v61h61v61h61h61v-61v-61h61v-61h61h61v-61h61 v61v61v61v61h61v-61v-61h61h61v-61h61v61h61v-61h61v-61h61v-61v-61h-61v61h-61v61h-61v-61h-61v-61h61v-61h-61v-61v-61v-61h-61v-61 v-61v-61v-61v-61h-61v61v61h-61h-61v61h61h61v61v61h-61v-61h-61v61v61h-61v-61v-61h61v-61h-61v-61v-61h61v-61h-61v-61h-61v-61h61 v-61v-61h61v-61h-61v-61v-61v-61v-61h61v61h61v-61h61h61h61v61v61h61v-61h61v-61H1952z M1708,1647h61h61v61v61v61h-61h-61h-61v-61 v-61v-61H1708z M1525,1586h-61v-61h61V1586z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "549,793 549,732 488,732 427,732 366,732 366,793 366,854 427,854 488,854 488,793  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "2074,732 2013,732 2013,793 2013,854 2013,915 2074,915 2135,915 2135,854 2135,793 2074,793  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "244,854 305,854 305,793 305,732 305,671 244,671 183,671 183,610 122,610 122,671 122,732 183,732  183,793 244,793  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "976,854 915,854 915,915 915,976 976,976 976,915 1037,915 1037,854 1037,793 976,793  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1647,793 1647,854 1708,854 1708,915 1769,915 1769,854 1769,793 1769,732 1708,732 1708,793  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "183,854 183,793 122,793 122,854 122,915 183,915  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 854,
    className: "st0",
    width: 61,
    height: 61
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1891,
    y: 854,
    className: "st0",
    width: 61,
    height: 61
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 915,
    className: "st0",
    width: 61,
    height: 61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1159,915 1098,915 1098,976 1098,1037 1159,1037 1159,976  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1769,
    y: 915,
    className: "st0",
    width: 61,
    height: 61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "488,976 427,976 427,915 366,915 366,976 366,1037 305,1037 244,1037 244,1098 305,1098 366,1098  427,1098 427,1037 488,1037 549,1037 549,976  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2013,
    y: 976,
    className: "st0",
    width: 61,
    height: 61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1769,1037 1769,976 1708,976 1647,976 1647,1037 1647,1098 1708,1098 1708,1159 1769,1159 1769,1098  1830,1098 1830,1159 1891,1159 1891,1220 1891,1281 1952,1281 1952,1220 2013,1220 2013,1159 1952,1159 1952,1098 1891,1098  1891,1037 1952,1037 1952,976 1891,976 1830,976 1830,1037  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 1098,
    className: "st0",
    width: 61,
    height: 61
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2013,
    y: 1098,
    className: "st0",
    width: 61,
    height: 61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "183,1220 244,1220 244,1281 305,1281 305,1220 366,1220 366,1159 305,1159 244,1159 183,1159  122,1159 122,1220 122,1281 122,1342 183,1342 183,1281  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1342,
    y: 1220,
    className: "st0",
    width: 61,
    height: 61
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2013,
    y: 1281,
    className: "st0",
    width: 61,
    height: 61
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 1342,
    className: "st0",
    width: 61,
    height: 61
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M549,1342h-61v61h61h61h61v61h-61v61h61h61v61h61v-61h61v-61v-61h61h61v-61h-61v-61h61v61h61v-61h61v61h-61v61 h61h61v-61v-61v-61h61v61h61v-61v-61v-61h-61v-61h-61v61h-61h-61v61h61v61h-61v-61h-61v-61h-61h-61v-61h61v-61h-61h-61v-61v-61h61 v-61h-61v-61h-61v-61h61v61h61v-61h61v-61v-61v-61h-61v61h-61v61h-61h-61v-61v-61h61v-61h-61v-61v-61h-61v61v61v61v61v61h-61h-61 v61h61v61h61v-61h61v61h-61v61h-61v61h61v61h-61v61h61v61h-61v61h61v61h61v61h61v-61h61h61v61v61v61h-61v-61h-61h-61h-61v61H549z  M732,1098h-61v-61h61h61v61H732z M793,1464h-61v-61h61V1464z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2074,
    y: 1342,
    className: "st0",
    width: 61,
    height: 61
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 1403,
    className: "st0",
    width: 61,
    height: 61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "305,1403 244,1403 244,1464 244,1525 305,1525 305,1464  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "427,1403 427,1342 427,1281 488,1281 549,1281 610,1281 610,1220 549,1220 488,1220 427,1220  366,1220 366,1281 366,1342 305,1342 305,1403 366,1403 366,1464 366,1525 305,1525 305,1586 305,1647 366,1647 427,1647 427,1586  427,1525 427,1464 488,1464 488,1403  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1952,1403 1952,1342 1891,1342 1891,1403 1891,1464 1952,1464 2013,1464 2013,1525 2074,1525  2074,1464 2074,1403 2013,1403  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 1464,
    className: "st0",
    width: 61,
    height: 61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "610,1525 549,1525 549,1586 488,1586 488,1647 549,1647 610,1647 610,1586  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "122,1586 122,1647 183,1647 244,1647 244,1586 183,1586  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 793,
    y: 1586,
    className: "st0",
    width: 61,
    height: 61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "671,1647 610,1647 610,1708 610,1769 671,1769 671,1708 732,1708 732,1647  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1098,1647 1037,1647 1037,1708 1037,1769 1098,1769 1098,1708 1159,1708 1159,1647  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1220,
    y: 1647,
    className: "st0",
    width: 61,
    height: 61
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1708,
    y: 1708,
    className: "st0",
    width: 61,
    height: 61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "2013,1769 2074,1769 2074,1708 2135,1708 2135,1647 2074,1647 2013,1647 1952,1647 1952,1708  2013,1708  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M915,1830h-61v-61h61h61v-61h-61h-61h-61h-61v61v61h-61h-61v61h61v61v61v61h-61v61h61h61v-61v-61h61h61v-61h61 h61v-61h-61V1830z M732,1952v-61h61v61H732z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1037,1830 976,1830 976,1891 1037,1891 1098,1891 1098,1830  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 915,
    y: 2013,
    className: "st0",
    width: 61,
    height: 61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1586,2074 1525,2074 1525,2135 1586,2135 1647,2135 1647,2074 1647,2013 1586,2013  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "976,2074 976,2135 1037,2135 1098,2135 1098,2074 1037,2074  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1891,
    y: 2074,
    className: "st0",
    width: 61,
    height: 61
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2074,
    y: 2074,
    className: "st0",
    width: 61,
    height: 61
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0) scale(4.27, 4.27)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 43.6,
    y: 43.6,
    className: "st1",
    width: 70,
    height: 70
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113.6,28.6h-70h-15v15v70v15h15h70h15v-15v-70v-15H113.6z M113.6,113.6h-70v-70h70V113.6z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1586,0) scale(4.27, 4.27)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 43.6,
    y: 43.6,
    className: "st1",
    width: 70,
    height: 70
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113.6,28.6h-70h-15v15v70v15h15h70h15v-15v-70v-15H113.6z M113.6,113.6h-70v-70h70V113.6z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,1586) scale(4.27, 4.27)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 43.6,
    y: 43.6,
    className: "st1",
    width: 70,
    height: 70
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113.6,28.6h-70h-15v15v70v15h15h70h15v-15v-70v-15H113.6z M113.6,113.6h-70v-70h70V113.6z"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(122,122) scale(1.83, 1.83)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.7,
    y: 66.7,
    className: "st0",
    width: 100,
    height: 100
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1708,122) scale(1.83, 1.83)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.7,
    y: 66.7,
    className: "st0",
    width: 100,
    height: 100
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(122,1708) scale(1.83, 1.83)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.7,
    y: 66.7,
    className: "st0",
    width: 100,
    height: 100
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWechatqrcode);
export default __webpack_public_path__ + "static/media/wechatqrcode.46c7c999e5a3ced5077ca369fe4b45c0.svg";
export { ForwardRef as ReactComponent };